/** Юрособа з GET /public/site; будь-яке поле може бути відсутнім. */
export interface LegalEntity {
  name?: string | null;
  address?: string | null;
  tax_id?: string | null;
}

// заглушка з сиду («ФОП (заповнити реквізити)») і подібні підказки для співробітників
const PLACEHOLDER = /заповнит|заполнит|\bfill\b|todo|tbd/i;

/**
 * Реквізити компанії показуємо клієнту лише тоді, коли вони справжні:
 * є назва без підказок для співробітників і є податковий номер. Інакше — нічого.
 */
export function realLegalEntity(le: LegalEntity | null | undefined): { name: string; address: string } | null {
  const name = le?.name?.trim() ?? '';
  const taxId = le?.tax_id?.trim() ?? '';
  if (!name || !taxId) return null;
  if (PLACEHOLDER.test(name)) return null;
  const address = le?.address?.trim() ?? '';
  return { name, address: PLACEHOLDER.test(address) ? '' : address };
}
